let flktyInstances = [];

function initFlickity() {
  destroyFlickity(); // Remove all previous sliders

  // Init only the mobile slider (.product-comparison-slider)
  const isMobile = window.innerWidth < 768;
  if (isMobile) {
    const mobileSliders = document.querySelectorAll('.product-comparison-slider');
    mobileSliders.forEach(slider => {
      const flkty = new Flickity(slider, {
        adaptiveHeight: true,
        avoidReflow: true,
        pageDots: false,
        cellAlign: "left",
        wrapAround: false,
        contain: true,
        prevNextButtons: true // ✅ Pfeile nur auf Mobile
      });
      flktyInstances.push(flkty);
    });
  }
}

function destroyFlickity() {
  flktyInstances.forEach(instance => {
    if (instance) instance.destroy();
  });
  flktyInstances = [];
}

document.addEventListener('DOMContentLoaded', () => {
  initFlickity();

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      destroyFlickity();
      initFlickity();
    }, 300);
  });
});
